import { UniformsUtils } from 'three/src/renderers/shaders/UniformsUtils';
import { ShaderLib } from '../shaders/ShaderLib';

const THREE = require('three');

/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>
 * }
 */

class MeshBasicTintAnimatedMaterial extends THREE.ShaderMaterial {
    constructor(parameters) {

        const { uniforms, vertexShader, fragmentShader } = ShaderLib.basicGradientMapAnimated;

        super({
            uniforms: UniformsUtils.clone(uniforms),
            vertexShader,
            fragmentShader
        });

        // Default values
        this.tintInfluence = 1.0;
        this.color0 = new THREE.Color(0x000000);
        this.color1 = new THREE.Color(0xffffff);

        // Default values of MeshBasicMaterial
        this.color = new THREE.Color(0xffffff); // emissive

        this.map = null;

        this.lightMap = null;
        this.lightMapIntensity = 1.0;

        this.aoMap = null;
        this.aoMapIntensity = 1.0;

        this.specularMap = null;

        this.alphaMap = null;

        this.envMap = null;
        this.combine = THREE.MultiplyOperation;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;

        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';

        this.skinning = false;
        this.morphTargets = false;

        // Overwrite ShaderMaterial flags and parameters:
        // (Some are switched off)

        this.fog = true;

        this.setValues(parameters);

        this.isMeshBasicMaterial = true;
    }

    set color0(value) {
        this.uniforms.color0.value = value;
    }

    get color0() {
        return this.uniforms.color0.value;
    }

    set color1(value) {
        this.uniforms.color1.value = value;
    }

    get color1() {
        return this.uniforms.color1.value;
    }

    set tintInfluence(value) {
        this.uniforms.tintInfluence.value = value;
    }

    get tintInfluence() {
        return this.uniforms.tintInfluence.value;
    }

    set animInfluence(value) {
        this.uniforms.animInfluence.value = value;
    }

    get animInfluence() {
        return this.uniforms.animInfluence.value;
    }
}

export default MeshBasicTintAnimatedMaterial;
